import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Schedules from "../pages/schedules/page";
import Amenities from "../pages/amenities/page";
import Fleet from "../pages/fleet/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/schedules",
    element: <Schedules />,
  },
  {
    path: "/amenities",
    element: <Amenities />,
  },
  {
    path: "/fleet",
    element: <Fleet />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
